export default {
  title: "Utility for people at basic demand and help",
  description: "Utility for people at basic demand and help"
};
